var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrustedSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trusted 1",
    clipPath: "url(#clip0_1271_13452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.70351 26.0191L0.0442171 30.6784C-0.0341422 30.7531 -0.00484536 30.8882 0.104373 30.9206L5.71594 32.6252C6.51203 32.8674 7.13234 33.4877 7.37445 34.2837L9.07906 39.8953C9.1114 40.0045 9.24656 40.0338 9.32125 39.9555L15.5555 33.7212C10.9429 32.5755 7.13484 29.6998 4.70351 26.0191Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.9567 30.6784L35.2974 26.0191C32.8834 29.6735 29.0872 32.5682 24.4453 33.7213L30.6795 39.9555C30.7542 40.0339 30.8894 40.0046 30.9217 39.8954L32.6263 34.2838C32.8685 33.4877 33.4888 32.8674 34.2849 32.6253L39.8965 30.9207C40.006 30.8881 40.0349 30.7529 39.9567 30.6784Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.9574 15.9584C35.9574 7.15943 28.799 0.000213623 19.9992 0.000213623C11.1995 0.000213623 4.04102 7.15943 4.04102 15.9584C4.04102 23.9143 9.89875 30.5452 17.547 31.7291C27.235 33.2362 35.9574 25.6954 35.9574 15.9584ZM7.55969 19.8474C4.92789 11.4333 11.2634 2.92748 19.9992 2.92748C29.758 2.92748 36.2083 13.4157 31.4513 22.1747C25.9595 32.249 11.0161 30.8415 7.55969 19.8474Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.0005 5.27118C14.1077 5.27118 9.3125 10.0656 9.3125 15.9584C9.3125 24.6281 19.142 29.6841 26.1809 24.6731C27.689 23.6026 28.9171 22.1391 29.7073 20.4294C32.991 13.3602 27.7564 5.27118 20.0005 5.27118ZM25.3949 14.4593C25.2615 14.5584 18.7683 19.3777 18.731 19.4053C18.262 19.7549 17.5948 19.708 17.1779 19.2663C14.1953 16.0877 14.4339 16.3415 14.3623 16.2663C13.8612 15.7327 13.9658 14.8695 14.5928 14.4727C14.5936 14.4719 14.5944 14.4711 14.5952 14.4711C15.0608 14.1789 15.6819 14.2469 16.0717 14.6625C16.7024 15.3347 16.2779 14.8823 18.1724 16.9007C18.3766 16.7484 20.7796 14.9658 24.0855 12.5125C24.6051 12.1266 25.3395 12.2352 25.7245 12.7547C26.0775 13.2284 26.0763 13.9545 25.3949 14.4593Z",
    fill: "#34A853"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1271_13452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedSvg);
export default __webpack_public_path__ + "static/media/TrustedSvg.24291dace294d9923ebea55a1adf07f3.svg";
export { ForwardRef as ReactComponent };